<template>
  <div class="animated fadeIn tickets">
    <div class="kt-portlet kt-portlet--mobile" style="position: relative">
      <div class="kt-portlet__body kt-portlet__body--fit" ref="cnt">
        <div class="m-4">
          <div
            class="container-fluid"
            v-if="typeof gross_winnings != 'undefined'"
          >
            <div class="text-center my-2 mb-4">
              {{ $t("Gross Winnings") }}:
              <strong>{{ round(gross_winnings) }}</strong>
              (
              {{ $t("Paid Winnings") }}:
              <strong>{{ round(paid_winnings) }}</strong>
              |
              {{ $t("Unpaid Winnings") }}:
              <strong>{{ round(unpaid_winnings) }}</strong>
              ) | {{ $t("Total Amount") }}:
              <strong>{{ round(total_amount) }}</strong>
              | {{ $t("Winnings Tax") }}:
              <strong>{{ round(winning_tax) }}</strong>
            </div>
          </div>
          <div class="filters-container">
            <TableFilters
              v-model="filterOptions"
              style="margin-right: 45px"
              @click="refresh"
              ref="filters"
            />
            <DropdownColumns
              v-model="fields"
              class="customize"
              :export-link="exportLink"
              :export-json="exportJson"
            />
          </div>
          <div>
            <div style="overflow-x: auto">
              <b-table
                id="tickets-table"
                :busy.sync="isBusy"
                show-empty
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :hover="true"
                :striped="true"
                stacked="md"
                v-model="copy"
                :items="provider"
                :fields="fields"
                :current-page="currentPage"
                :per-page="perPage"
                @row-clicked="rowClicked"
                tbody-tr-class="tr-pointer"
                v-columns-resizable="{ afterResize: columnsWidthChanged }"
              >
                <template v-slot:empty="scope">
                  <div class="text-center">{{ $t(scope.emptyText) }}</div>
                </template>

                <template v-slot:head(eid)="data">{{
                  $t(data.label)
                }}</template>
                <template v-slot:head(eshop_id)="data">{{
                  $t(data.label)
                }}</template>
                <template v-slot:head(epaid_shop_id)="data">{{
                  $t(data.label)
                }}</template>
                <template v-slot:head(etenant_id)="data">{{
                  $t(data.label)
                }}</template>
                <template v-slot:head(eterminal_id)="data">{{
                  $t(data.label)
                }}</template>
                <template v-slot:head(euser_id)="data">{{
                  $t(data.label)
                }}</template>
                <template v-slot:head(ticket_id)="data">{{
                  $t(data.label)
                }}</template>
                <template v-slot:head(total_amount)="data">{{
                  $t(data.label)
                }}</template>
                <template v-slot:head(bonus_amount_used)="data">{{
                  $t(data.label)
                }}</template>
                <template v-slot:head(stake)="data">{{
                  $t(data.label)
                }}</template>
                <template v-slot:head(registration_time)="data">{{
                  $t(data.label)
                }}</template>
                <template v-slot:head(tax)="data">{{
                  $t(data.label)
                }}</template>
                <template v-slot:head(event_name)="data">{{
                  $t(data.label)
                }}</template>
                <template v-slot:head(event_time)="data">{{
                  $t(data.label)
                }}</template>
                <template v-slot:head(event_code)="data">{{
                  $t(data.label)
                }}</template>
                <template v-slot:head(selected_numbers)="data">{{
                  $t(data.label)
                }}</template>
                <template v-slot:head(number_of_lines)="data">{{
                  $t(data.label)
                }}</template>
                <template v-slot:head(ticket_systems)="data">{{
                  $t(data.label)
                }}</template>
                <template v-slot:head(status)="data">{{
                  $t(data.label)
                }}</template>
                <template v-slot:head(is_valid)="data">{{
                  $t(data.label)
                }}</template>
                <template v-slot:head(gross_winning_amount)="data">{{
                  $t(data.label)
                }}</template>
                <template v-slot:head(winning_tax)="data">{{
                  $t(data.label)
                }}</template>
                <template v-slot:head(net_winning_amount)="data">{{
                  $t(data.label)
                }}</template>
                <template v-slot:head(paid_time)="data">{{
                  $t(data.label)
                }}</template>
                <template v-slot:head(epaid_by_user_id)="data">{{
                  $t(data.label)
                }}</template>
                <template v-slot:head(eplayer_id)="data">{{
                  $t(data.label)
                }}</template>
                <!--<template v-slot:head(eonline_player_id)="data">{{ $t(data.label) }}</template>-->
                <template v-slot:head(ethird_party_player_id)="data">{{
                  $t(data.label)
                }}</template>
                <template v-slot:head(odds)="data">{{
                  $t(data.label)
                }}</template>
                <template v-slot:head(custom_odds)="data">{{
                  $t(data.label)
                }}</template>
                <template v-slot:head(is_web_ticket)="data">{{
                  $t(data.label)
                }}</template>
                <template v-slot:head(authorized)="data">{{
                  $t(data.label)
                }}</template>
                <template v-slot:head(eauthorized_by_user_id)="data">{{
                  $t(data.label)
                }}</template>
                <template v-slot:head(cancel_time)="data">{{
                  $t(data.label)
                }}</template>
                <template v-slot:head(processing_time)="data">{{
                  $t(data.label)
                }}</template>
                <template v-slot:head(processing_routine_id)="data">{{
                  $t(data.label)
                }}</template>
                <template v-slot:head(expiration_time)="data">{{
                  $t(data.label)
                }}</template>
                <template v-slot:head(pin)="data">{{
                  $t(data.label)
                }}</template>
                <template v-slot:head(save_time)="data">{{
                  $t(data.label)
                }}</template>
                <template v-slot:head(max_winning)="data">{{
                  $t(data.label)
                }}</template>
                <template v-slot:head(min_winning)="data">{{
                  $t(data.label)
                }}</template>
                <template v-slot:head(test)="data">{{
                  $t(data.label)
                }}</template>
                <template v-slot:head(cancel_reason)="data">{{
                  $t(data.label)
                }}</template>
                <template v-slot:head(reprinted)="data">{{
                  $t(data.label)
                }}</template>
                <template v-slot:head(reserve_transaction_id)="data">{{
                  $t(data.label)
                }}</template>
                <template v-slot:head(settle_transaction_id)="data">{{
                  $t(data.label)
                }}</template>
                <template v-slot:head(free_bet)="data">{{
                  $t(data.label)
                }}</template>

                <template v-slot:cell(total_amount)="data">{{
                  roundThousands(data.value)
                }}</template>
                <template v-slot:cell(bonus_amount_used)="data">{{
                  roundThousands(data.value)
                }}</template>
                <template v-slot:cell(tax)="data">{{
                  roundThousands(data.value)
                }}</template>
                <template v-slot:cell(stake)="data">{{
                  roundThousands(data.value)
                }}</template>
                <template v-slot:cell(gross_winning_amount)="data">{{
                  roundThousands(data.value)
                }}</template>
                <template v-slot:cell(winning_tax)="data">{{
                  roundThousands(data.value)
                }}</template>
                <template v-slot:cell(net_winning_amount)="data">{{
                  roundThousands(data.value)
                }}</template>
                <template v-slot:cell(max_winning)="data">{{
                  roundThousands(data.value)
                }}</template>
                <template v-slot:cell(min_winning)="data">{{
                  roundThousands(data.value)
                }}</template>

                <template v-slot:cell(reprinted)="data">
                  <span v-if="data.value">
                    <span v-if="data.value && data.value.length > 0">{{
                      data.value.length
                    }}</span>
                  </span>
                </template>

                <template v-slot:cell(etenant_id)="data">
                  <span v-if="data.value">
                    <span v-if="data.value.to">
                      <router-link :to="`/tenants/${data.value.to}`">{{
                        data.value.name
                      }}</router-link>
                    </span>
                    <span v-else>{{ data.value.name }}</span>
                  </span>
                </template>

                <template v-slot:cell(eshop_id)="data">
                  <span v-if="data.value">
                    <span v-if="data.value.to">
                      <router-link :to="`/shops/${data.value.to}`">{{
                        data.value.name
                      }}</router-link>
                    </span>
                    <span v-else>{{ data.value.name }}</span>
                  </span>
                </template>

                <template v-slot:cell(epaid_shop_id)="data">
                  <span v-if="data.value">
                    <span v-if="data.value.to">
                      <router-link :to="`/shops/${data.value.to}`">{{
                        data.value.name
                      }}</router-link>
                    </span>
                    <span v-else>{{ data.value.name }}</span>
                  </span>
                </template>

                <template v-slot:cell(authorized)="data">
                  <div v-if="data.value" class="text-center">
                    <i class="fa fa-check" style="color: #1d7c72" />
                  </div>
                </template>

                <template v-slot:cell(test)="data">
                  <div v-if="data.value" class="text-center">
                    {{ $t("YES") }}
                  </div>
                  <div v-else class="text-center">{{ $t("NO") }}</div>
                </template>

                <template v-slot:cell(event_name)="data">
                  <span v-if="data.value">
                    <span v-if="data.value.to">
                      <router-link :to="`/lottery-events/${data.value.to}`">{{
                        data.value.name
                      }}</router-link>
                    </span>
                    <span v-else>{{ data.value.name }}</span>
                  </span>
                </template>

                <template v-slot:cell(eterminal_id)="data">
                  <span v-if="data.value">
                    <span v-if="data.item.eshop_id.to">
                      <router-link :to="`/shops/${data.item.eshop_id.to}`">{{
                        data.value
                      }}</router-link>
                    </span>
                    <span v-else>{{ data.value }}</span>
                  </span>
                </template>

                <template v-slot:cell(euser_id)="data">
                  <span v-if="data.value">
                    <span v-if="data.value.to">
                      <router-link :to="`/users/${data.value.to}`">{{
                        data.value.name
                      }}</router-link>
                    </span>
                    <span v-else>{{ data.value.name }}</span>
                  </span>
                </template>

                <template v-slot:cell(epaid_by_user_id)="data">
                  <span v-if="data.value">
                    <span v-if="data.value.to">
                      <router-link :to="`/users/${data.value.to}`">{{
                        data.value.name
                      }}</router-link>
                    </span>
                    <span v-else>{{ data.value.name }}</span>
                  </span>
                </template>

                <template v-slot:cell(eauthorized_by_user_id)="data">
                  <span v-if="data.value">
                    <span v-if="data.value.to">
                      <router-link :to="`/users/${data.value.to}`">{{
                        data.value.name
                      }}</router-link>
                    </span>
                    <span v-else>{{ data.value.name }}</span>
                  </span>
                </template>

                <template v-slot:cell(ecancel_by_user_id)="data">
                  <span v-if="data.value">
                    <span v-if="data.value.to">
                      <router-link :to="`/users/${data.value.to}`">{{
                        data.value.name
                      }}</router-link>
                    </span>
                    <span v-else>{{ data.value.name }}</span>
                  </span>
                </template>

                <template v-slot:cell(eplayer_id)="data">
                  <span v-if="data.value">
                    <span v-if="data.value.to">
                      <router-link :to="`/players/${data.value.to}`">{{
                        data.value.name
                      }}</router-link>
                    </span>
                    <span v-else>{{ data.value.name }}</span>
                  </span>
                </template>

                <!--
                <template v-slot:cell(eonline_player_id)="data">
                  <span v-if="data.value">
                    <span v-if="data.value.to">
                      <router-link :to="`/online-players/${data.value.to}`">{{ data.value.name }}</router-link>
                    </span>
                    <span v-else>{{ data.value.name }}</span>
                  </span>
                </template>
                -->

                <template v-slot:cell(ethird_party_player_id)="data">
                  <span v-if="data.value">
                    <span v-if="data.value.to">
                      <router-link
                        :to="`/third-party-players/${data.value.to}`"
                        >{{ data.value.name }}</router-link
                      >
                    </span>
                    <span v-else>{{ data.value.name }}</span>
                  </span>
                </template>

                <template v-slot:cell(status)="data">{{
                  $t(data.value)
                }}</template>
                <template v-slot:cell(is_valid)="data">{{
                  $t(data.value)
                }}</template>

                <template v-slot:cell(registration_time)="data">{{
                  mom_unix(data.value).format(tableDateMedium)
                }}</template>
                <template v-slot:cell(event_time)="data">{{
                  mom_unix(data.value).format(tableDateMedium)
                }}</template>
                <template v-slot:cell(paid_time)="data">{{
                  mom_unix(data.value).format(tableDateMedium)
                }}</template>
                <template v-slot:cell(cancel_time)="data">{{
                  mom_unix(data.value).format(tableDateMedium)
                }}</template>
                <template v-slot:cell(processing_time)="data">{{
                  mom_unix(data.value).format(tableDateMedium)
                }}</template>
                <template v-slot:cell(expiration_time)="data">{{
                  mom_unix(data.value).format(tableDateMedium)
                }}</template>
                <template v-slot:cell(save_time)="data">{{
                  mom_unix(data.value).format(tableDateMedium)
                }}</template>

                <template v-slot:head(selected)>
                  <label
                    class="
                      kt-checkbox
                      kt-checkbox--single
                      kt-checkbox--all
                      kt-checkbox--solid
                    "
                  >
                    <input
                      type="checkbox"
                      @click.stop
                      @change="selectAll"
                      v-model="checkAll"
                    />
                    <span></span>
                  </label>
                </template>
                <template v-slot:cell(selected)="data">
                  <label
                    class="
                      kt-checkbox
                      kt-checkbox--single
                      kt-checkbox--all
                      kt-checkbox--solid
                    "
                  >
                    <input
                      type="checkbox"
                      @click.stop
                      :value="data.item.eid"
                      v-model="selected"
                    />
                    <span></span>
                  </label>
                </template>
              </b-table>
            </div>
            <div class="container-fluid">
              <div class="row">
                <div style="white-space: nowrap" class="my-2">
                  <BulkActionSelect
                    v-model="bulkAction"
                    :options="bulkActionOptions"
                    variant="light"
                    class="mr-2"
                    size="sm"
                    v-if="selected.length"
                  />
                  <b-button
                    @click.stop="applySelected()"
                    size="sm"
                    class="mr-2 refresh"
                    variant="light"
                    v-if="selected.length"
                    :disabled="!bulkAction"
                    >{{ $t("Apply") }}</b-button
                  >
                  <span class="pagination-sep" v-if="selected.length"></span>
                  <PaginationSelect
                    v-model="perPage"
                    :options="paginationOpts"
                    variant="light"
                    size="sm"
                  />
                  <span>
                    &nbsp;
                    <i18n
                      path="Showing {start}-{end} of {total} rows"
                      tag="span"
                    >
                      <span slot="start">{{
                        (currentPage - 1) * perPage + 1
                      }}</span>
                      <span slot="end">{{ currentPage * perPage }}</span>
                      <span slot="total">{{ totalRows }}</span>
                    </i18n>
                  </span>
                  <b-button
                    size="sm"
                    @click.stop="
                      $root.$emit('bv::refresh::table', 'tickets-table')
                    "
                    class="ml-2 refresh"
                    variant="light"
                    :title="$t('Refresh')"
                  >
                    <i class="icon-refresh"></i>
                  </b-button>
                </div>
                <nav class="ml-auto mt-2">
                  <b-pagination
                    size="md"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    v-model="currentPage"
                  />
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="modal-bulk-action" size="lg">
      <template slot="modal-title">
        <span v-if="bulkType === 1">{{ $t("Cancel Tickets") }}</span>
        <span v-if="bulkType === 2">{{ $t("Void Tickets") }}</span>
        <span v-if="bulkType === 3">{{ $t("Invalidate Payment") }}</span>
      </template>
      <template slot="modal-header-close">
        <span />
      </template>
      <div>
        <div class="my-2">
          <span v-if="bulkType === 1">{{ $t("Cancel tickets") }}</span>
          <span v-if="bulkType === 2">{{ $t("Void tickets") }}</span>
          <span v-if="bulkType === 3">{{ $t("Invalidate payment") }}</span>
          : {{ selected.length }} {{ $t("tickets") }}
        </div>
        <div class="my-4" v-if="bulkType === 1">
          <FloatingLabel
            v-model="bulkReason"
            label="Reason"
            size="sm"
            type="textarea"
          />
        </div>
        <div class="my-2">
          <b-progress
            :value="progressTickets"
            :max="totalTickets"
            show-value
            :animated="progressTickets !== totalTickets"
          ></b-progress>
        </div>
        <div v-if="bulkSuccess" class="my-2 text-success">
          <span v-if="bulkType === 1">{{
            $t("The tickets have been canceled")
          }}</span>
          <span v-if="bulkType === 2">{{
            $t("The tickets have been voided")
          }}</span>
          <span v-if="bulkType === 3">{{
            $t("Payment has been invalidated for tickets")
          }}</span>
        </div>
        <div v-if="bulkError" class="my-2 text-danger">
          {{ $t("Error") }}: {{ $t(bulkErrorMsg) }}
        </div>
      </div>
      <template slot="modal-footer">
        <b-button variant="secondary" @click="cancel()">{{
          $t("Cancel")
        }}</b-button>
        <b-button
          v-if="bulkType === 1 && !bulkSuccess"
          variant="success"
          @click="cancelTickets()"
          >{{ $t("Cancel Tickets") }} ({{ progressTickets }}/{{
            totalTickets
          }})</b-button
        >
        <b-button
          v-if="bulkType === 2 && !bulkSuccess"
          variant="success"
          @click="voidTickets()"
          >{{ $t("Void Tickets") }} ({{ progressTickets }}/{{
            totalTickets
          }})</b-button
        >
        <b-button
          v-if="bulkType === 3 && !bulkSuccess"
          variant="success"
          @click="invalidatePayment()"
          >{{ $t("Invalidate Payment") }} ({{ progressTickets }}/{{
            totalTickets
          }})</b-button
        >
      </template>
    </b-modal>
  </div>
</template>

<script>
import moment from "moment";
import startCase from "@/shared/strings";
import { errorConf } from "@/shared/notifications";
import tableMixin from "@/shared/mixins/table.mixin";
import PaginationSelect from "@/components/PaginationSelect";
import DropdownColumns from "@/components/DropdownColumns";
import TableFilters from "@/components/TableFilters";
import BulkActionSelect from "@/components/BulkActionSelect";
import FloatingLabel from "@/components/FloatingLabel";

export default {
  components: {
    PaginationSelect,
    DropdownColumns,
    TableFilters,
    BulkActionSelect,
    FloatingLabel,
  },
  name: "Tickets",
  mixins: [tableMixin],
  data: function () {
    return {
      tableName: "tickets",

      bulkAction: null,
      bulkActionOptions: [
        { text: "Cancel Tickets", field: "flags", value: 1 },
        { text: "Void Tickets", field: "flags", value: 2 },
        { text: "Invalidate Payments", field: "flags", value: 3 },
      ],

      filterOptions: [
        {
          field: "tenant_id",
          multiple: true,
          placeholder: "Tenant",
          trackBy: "eid",
          label: "brand_name",
          store: "tenants",
          translate: false,
          options: [],
          selected: [],
        },
        {
          field: "shop_id",
          multiple: true,
          placeholder: "Shop",
          trackBy: "eid",
          label: "name",
          store: "shops",
          translate: false,
          options: [],
          selected: [],
        },
        {
          field: "event_id",
          multiple: true,
          placeholder: "Lottery Events",
          customLabel: ({ system_name, n, r, schedule_time }) => {
            return `${system_name} ${r}/${n} ${moment
              .unix(schedule_time / 1e9)
              .format("DD-MM-YY, HH:mm")}`;
          },
          trackBy: "eid",
          label: "system_name",
          store: "lotteryEvents",
          translate: false,
          dateField: "schedule_time",
          options: [],
          selected: [],
        },
        {
          field: "third_party_player_id",
          multiple: true,
          placeholder: "Third Party Players",
          customLabel: ({ name, surname, email }) => {
            return `${name} ${surname} (${email})`;
          },
          trackBy: "eid",
          label: "email",
          store: "thirdPartyPlayers",
          translate: false,
          minLength: 3,
          options: [],
          selected: [],
          remote: true,
          likeFields: ["email"],
        },
        {
          field: "is_web_ticket",
          multiple: true,
          placeholder: "Reserved",
          options: [
            { name: "Desktop", value: false },
            { name: "Mobile", value: true },
          ],
          selected: [],
        },
        {
          field: "status",
          multiple: true,
          placeholder: "Status",
          options: [
            { name: "Open", value: 0 },
            { name: "Winner", value: 1 },
            { name: "Lost", value: 2 },
            { name: "Paid", value: 3 },
            { name: "Expired", value: 4 },
          ],
          selected: [],
        },
        {
          field: "is_valid",
          multiple: true,
          placeholder: "Is Valid",
          options: [
            { name: "Canceled", value: 0 },
            { name: "Is valid", value: 1 },
            { name: "Rejected", value: 2 },
            { name: "Manual Authorization", value: 3 },
            { name: "Authorized", value: 4 },
            { name: "Void", value: 5 },
          ],
          selected: [],
        },
        {
          field: "test",
          multiple: false,
          placeholder: "Test",
          options: [
            { name: "Test Mode", value: true },
            { name: "Live Mode", value: false },
          ],
          selected: [{ name: "Live Mode", value: false }],
        },
        {
          field: "free_bet_switch",
          multiple: false,
          placeholder: "Free Bet",
          options: [
            { name: "No", value: false },
            { name: "Yes", value: true },
          ],
          selected: [],
        },
        {
          field: "save_time",
          type: "date",
          selected: {
            startDate: moment().startOf("day"),
            endDate: moment().endOf("day"),
          },
          default: {
            startDate: moment().startOf("day"),
            endDate: moment().endOf("day"),
          },
        },
      ],

      isBusy: false,
      sortBy: "save_time",
      sortDesc: true,
      fields: [
        {
          key: "selected",
          selected: false,
          ignore: true,
          class: "mw-select",
          dpIgnore: true,
        },
        {
          key: "eid",
          label: "Id",
          sortable: false,
          ignore: true,
          class: "d-none",
        },
        {
          key: "etenant_id",
          label: "Tenant",
          sortable: true,
          ignore: true,
          class: "d-none",
        },
        {
          key: "eshop_id",
          label: "Shop",
          sortable: true,
          ignore: true,
          class: "",
        },
        {
          key: "eterminal_id",
          label: "Terminal",
          sortable: true,
          ignore: true,
          class: "d-none",
        },
        {
          key: "euser_id",
          label: "User",
          sortable: true,
          ignore: true,
          class: "",
        },
        {
          key: "ticket_id",
          label: "Serial",
          sortable: true,
          class: "",
        },
        { key: "event_name", sortable: true, class: "" },
        { key: "event_time", sortable: true, class: "", ignore: true },
        { key: "event_code", sortable: true, class: "d-none" },
        {
          key: "total_amount",
          label: "Total Amount",
          sortable: true,
          ignore: true,
          class: "",
        },
        {
          key: "bonus_amount_used",
          label: "Bonus Amount",
          sortable: true,
          ignore: true,
          class: "",
        },
        {
          key: "save_time",
          label: "Save Time",
          sortable: true,
          ignore: true,
          class: "",
        },
        {
          key: "stake",
          label: "Stake",
          sortable: true,
          ignore: true,
          class: "d-none",
        },
        {
          key: "tax",
          label: "Tax",
          sortable: true,
          ignore: true,
          class: "d-none",
        },

        {
          key: "selected_numbers",
          sortable: true,
          class: "d-none",
          ignore: true,
        },
        {
          key: "number_of_lines",
          sortable: true,
          class: "d-none",
          ignore: true,
        },
        { key: "ticket_systems", sortable: false, class: "", ignore: true },
        { key: "status", sortable: true, class: "", ignore: true },
        { key: "is_valid", sortable: true, class: "", ignore: true },
        {
          key: "gross_winning_amount",
          sortable: true,
          class: "",
          ignore: true,
        },
        { key: "winning_tax", sortable: true, class: "", ignore: true },
        {
          key: "net_winning_amount",
          sortable: true,
          class: "d-none",
          ignore: true,
        },
        { key: "paid_time", sortable: true, class: "", ignore: true },
        {
          key: "epaid_by_user_id",
          label: "Paid by User",
          sortable: true,
          class: "d-none",
          ignore: true,
        },
        {
          key: "epaid_shop_id",
          label: "Paid in Shop",
          sortable: true,
          class: "d-none",
          ignore: true,
        },
        {
          key: "eplayer_id",
          label: "Player",
          sortable: true,
          class: "d-none",
          ignore: true,
        },
        {
          key: "cnp",
          label: "CNP",
          sortable: false,
          class: "d-none",
        },

        /*
        {
          key: "eonline_player_id",
          label: "Online Player",
          sortable: true,
          class: "d-none",
          ignore: true
        },
        */
        {
          key: "ethird_party_player_id",
          label: "Third Party Player",
          sortable: true,
          class: "d-none",
          ignore: true,
        },
        { key: "odds", sortable: true, class: "d-none", ignore: true },
        { key: "custom_odds", sortable: true, class: "d-none", ignore: true },
        { key: "is_web_ticket", sortable: true, class: "d-none", ignore: true },
        { key: "authorized", sortable: true, class: "d-none", ignore: true },
        {
          key: "eauthorized_by_user_id",
          label: "Authorized by User Id",
          sortable: true,
          class: "d-none",
          ignore: true,
        },
        {
          key: "refusal_reason",
          label: "Refusal Reason",
          sortable: true,
          class: "d-none",
          ignore: true,
        },
        { key: "cancel_time", sortable: true, class: "d-none", ignore: true },
        {
          key: "ecancel_by_user_id",
          label: "Canceled by User Id",
          sortable: true,
          class: "d-none",
          ignore: true,
        },
        {
          key: "cancel_reason",
          sortable: false,
          class: "d-none",
          ignore: true,
        },
        {
          key: "processing_time",
          sortable: true,
          class: "d-none",
          ignore: true,
        },
        {
          key: "processing_routine_id",
          sortable: true,
          class: "d-none",
          ignore: true,
        },
        {
          key: "expiration_time",
          sortable: true,
          class: "d-none",
          ignore: true,
        },
        { key: "pin", sortable: true, class: "d-none", ignore: true },
        {
          key: "registration_time",
          label: "Registration",
          sortable: false,
          class: "d-none",
          ignore: true,
        },
        { key: "max_winning", sortable: true, class: "d-none", ignore: true },
        { key: "min_winning", sortable: true, class: "d-none", ignore: true },
        { key: "reprinted", sortable: true, class: "d-none", ignore: true },
        { key: "test", sortable: false, class: "d-none", ignore: true },
        {
          key: "reserve_transaction_id",
          label: "Reserve Transaction ID",
          sortable: true,
          class: "",
          ignore: true,
        },
        {
          key: "settle_transaction_id",
          label: "Settle Transaction ID",
          sortable: true,
          class: "",
          ignore: true,
        },
        {
          key: "free_bet",
          label: "Free Bet ID",
          sortable: true,
          class: "d-none",
        },
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      filter: null,
      filterField: null,
      checkAll: false,
      selected: [],
      bulkType: null,
      copy: null,
      addLabel: "",
      progressTickets: 0,
      totalTickets: 0,
      bulkSuccess: false,
      bulkError: false,
      bulkErrorMsg: "",
      bulkReason: "",

      hasEventFilter: false,
      gross_winnings: 0,
      total_amount: 0,

      winning_tax: 0,
      paid_winnings: 0,
      unpaid_winnings: 0,
    };
  },
  watch: {
    selected(val) {
      if (val.length != this.copy.length) {
        this.checkAll = false;
      }
    },
  },
  beforeMount() {
    const self = this;
    const event_id = this.$route.query.lid;
    if (event_id) {
      this.hasEventFilter = true;
      this.$store.dispatch("cache/fetch", "lotteryEvents").then((resp) => {
        resp.forEach((item) => {
          if (item.eid == event_id) {
            self.$refs.filters.setFilter(
              "event_id",
              JSON.parse(JSON.stringify(item))
            );
            self.$nextTick(() => {
              self.refresh();
            });
          }
        });
      });
    }
  },
  computed: {
    lang() {
      return this.$store.getters["global/defLanguage"];
    },
    exportLink() {
      const apiUrl = this.$store.getters["global/apiUrl"];
      const endpoint = this.$store.getters["ticket/endpoint"];

      return `${apiUrl}/${endpoint}s?export=xls&lang=${this.lang}`;
    },
    exportJson() {
      const fields = [];
      this.fields.forEach((item) => {
        if (
          typeof item.class != "undefined" &&
          item.class.indexOf("d-none") == -1
        ) {
          let key = item.key;
          if (key != "selected") {
            const efields = [
              "eid",
              "ecancel_by_user_id",
              "eauthorized_by_user_id",
              "eplayer_id",
              // "eonline_player_id",
              "ethird_party_player_id",
              "epaid_by_user_id",
              "epaid_shop_id",
              "euser_id",
              "eterminal_id",
              "eshop_id",
              "etenant_id",
            ];

            if (efields.indexOf(key) > -1) {
              key = key.substr(1);
            }

            fields.push(key);
          }
        }
      });

      const paginationData = this.buildPagination();

      paginationData.fields = fields;

      return JSON.stringify(paginationData);
    },
  },
  mounted() {
    this.$root.$on("bv::modal::hidden", (bvEvent, modalId) => {
      if (modalId == "modal-bulk-action") {
        this.bulkSuccess = false;
        this.bulkError = false;
        this.bulkErrorMsg = "";
        this.bulkReason = "";
        this.allSelected = false;
        this.selected = [];
        this.progressTickets = 0;
        this.totalTickets = 0;
        this.refresh();
      }
    });
  },
  destroyed() {
    this.$root.$off("bv::modal::hidden");
  },
  methods: {
    cancel() {
      this.$bvModal.hide("modal-bulk-action");
    },
    async cancelTickets() {
      this.bulkSuccess = false;
      this.bulkError = false;
      this.bulkErrorMsg = "";

      const startFrom = this.progressTickets;

      for (let i = startFrom; i < this.selected.length; i++) {
        const selected = this.selected[i];
        let selectedData = null;

        this.copy.forEach((elem) => {
          if (elem.eid === selected) {
            selectedData = elem;
          }
        });

        if (!selectedData || !selectedData.pin) {
          this.bulkError = true;
          this.bulkErrorMsg =
            "You don't appear to have ticket cancel permissions";
          this.progressTickets = this.progressTickets + 1;
          return;
        }

        const data = {
          eticket_id: selected,
          pin: selectedData.pin,
          reason: this.bulkReason,
        };

        console.log("selected", data);

        if (selectedData.is_valid === "Valid") {
          try {
            const res = await this.$store.dispatch("ticket/cancel", data);
          } catch (err) {
            this.bulkError = true;
            this.bulkErrorMsg =
              err.details && err.details.length ? err.details[0] : err.message;
            this.progressTickets = this.progressTickets + 1;
            return;
          }
        } else {
          this.bulkError = true;
          this.bulkErrorMsg =
            "You're trying to cancel a ticket that can't be canceled";
          this.progressTickets = this.progressTickets + 1;
          return;
        }
        this.progressTickets = this.progressTickets + 1;
      }
      this.bulkSuccess = true;
    },
    async voidTickets() {
      this.bulkSuccess = false;
      this.bulkError = false;
      this.bulkErrorMsg = "";

      const startFrom = this.progressTickets;

      for (let i = startFrom; i < this.selected.length; i++) {
        let selectedData = null;

        this.copy.forEach((elem) => {
          if (elem.eid === this.selected[i]) {
            selectedData = elem;
          }
        });
        const data = {
          eticket_id: this.selected[i],
        };

        console.log("selected", data);
        if (selectedData.is_valid === "Valid") {
          try {
            const res = await this.$store.dispatch("ticket/void", data);
          } catch (err) {
            this.bulkError = true;
            this.bulkErrorMsg =
              err.details && err.details.length ? err.details[0] : err.message;
            this.progressTickets = this.progressTickets + 1;
            return;
          }
        } else {
          this.bulkError = true;
          this.bulkErrorMsg =
            "You're trying to void a ticket that can't be voided";
          this.progressTickets = this.progressTickets + 1;
          return;
        }
        this.progressTickets = this.progressTickets + 1;
      }
      this.bulkSuccess = true;
    },
    async invalidatePayment() {
      this.bulkSuccess = false;
      this.bulkError = false;
      this.bulkErrorMsg = "";

      const startFrom = this.progressTickets;

      for (let i = startFrom; i < this.selected.length; i++) {
        let selectedData = null;

        this.copy.forEach((elem) => {
          if (elem.eid === this.selected[i]) {
            selectedData = elem;
          }
        });

        const data = {
          eticket_id: this.selected[i],
        };
        console.log("selected", data);

        if (
          selectedData.is_valid === "Valid" &&
          selectedData.status === "Paid"
        ) {
          try {
            const res = await this.$store.dispatch(
              "ticket/invalidatePayment",
              data
            );
          } catch (err) {
            this.bulkError = true;
            this.bulkErrorMsg =
              err.details && err.details.length ? err.details[0] : err.message;
            this.progressTickets = this.progressTickets + 1;
            return;
          }
        } else {
          this.bulkError = true;
          this.bulkErrorMsg =
            "You're trying to invalidate a payment for an invalid ticket";
          this.progressTickets = this.progressTickets + 1;
          return;
        }
        this.progressTickets = this.progressTickets + 1;
      }
      this.bulkSuccess = true;
    },
    refresh() {
      this.$root.$emit("bv::refresh::table", "tickets-table");
    },
    selectAll() {
      this.selected = [];
      this.copy.forEach((item) => {
        if (this.checkAll) {
          this.selected.push(item.eid);
        }
      });
    },
    applySelected() {
      this.bulkType = this.bulkAction.value;
      this.progressTickets = 0;
      this.totalTickets = this.selected.length;
      this.$bvModal.show("modal-bulk-action");
    },
    buildPagination() {
      const paginationData = {
        rowsPerPage: this.perPage,
        page: this.currentPage,
      };

      if (this.filter && this.filterField) {
        paginationData.likeValues = [this.filter];
        paginationData.likeFields = [this.filterField];
      } else {
        paginationData.likeValues = [];
        paginationData.likeFields = [];
      }

      if (this.sortBy) {
        let sortBy = this.sortBy;
        if (sortBy == "etenant_id") sortBy = "tenant_id";
        if (sortBy == "eshop_id") sortBy = "shop_id";
        if (sortBy == "eterminal_id") sortBy = "terminal_id";
        if (sortBy == "euser_id") sortBy = "user_id";
        if (sortBy == "epaid_by_user_id") sortBy = "paid_by_user_id";
        if (sortBy == "eauthorized_by_user_id")
          sortBy = "authorized_by_user_id";
        if (sortBy == "ecancel_by_user_id") sortBy = "cancel_by_user_id";
        if (sortBy == "eplayer_id") sortBy = "player_id";
        // if (sortBy == "eonline_player_id") sortBy = "online_player_id";
        if (sortBy == "ethird_party_player_id")
          sortBy = "third_party_player_id";
        paginationData.sortBy = [sortBy];
        paginationData.sortDirection = [this.sortDesc ? "DESC" : "ASC"];

        if (sortBy == "gross_winning_amount") {
          if (this.sortDesc) {
            paginationData.sortNulls = ["NULLS LAST"];
          }
        }
      }

      const exactFields = [];
      const exactValues = [];

      this.filterOptions.forEach((item) => {
        if (item.field === "free_bet_switch") {
          if (item.selected.length > 0) {
            if (item.selected[0]) {
              exactFields.push("!ISNULL free_bet");
              exactValues.push([""]);
            } else {
              exactFields.push("ISNULL free_bet");
              exactValues.push([""]);
            }
          }
          return;
        } else if (item.type != "date" && item.selected.length) {
          exactFields.push(item.field);
          if (item.trackBy) {
            const tmp = [];
            item.selected.forEach((el) => {
              tmp.push(el[item.trackBy]);
            });
            exactValues.push(tmp);
          } else {
            exactValues.push(item.selected);
          }
        } else if (item.type == "date") {
          if (item.selected.startDate && item.selected.endDate) {
            paginationData.dateField = item.field;
            paginationData.dateStart = item.selected.startDate;
            paginationData.dateEnd = item.selected.endDate;
          }
        }
      });

      if (exactFields.length) {
        paginationData.exactFields = exactFields;
        paginationData.exactValues = exactValues;
      }

      return paginationData;
    },
    provider(ctx, callback) {
      if (this.hasEventFilter) {
        this.hasEventFilter = false;
        callback([]);
        return;
      }
      const loading = this.$loading.open({
        container: this.$refs.cnt,
      });

      const paginationData = this.buildPagination();

      paginationData.sum = true;

      const tenantByID = this.$store.getters["cache/tenantByID"];
      const userByID = this.$store.getters["cache/userByID"];
      const shopByID = this.$store.getters["cache/shopByID"];
      const playerByID = this.$store.getters["cacheOnDemand/playerByID"];
      //const onlinePlayerByID = this.$store.getters["cache/onlinePlayerByID"];
      const thirdPartyPlayerByID =
        this.$store.getters["cacheOnDemand/thirdPartyPlayerByID"];

      const status = ["Open", "Winner", "Lost", "Paid", "Expired"];
      const is_valid = [
        "Canceled",
        "Valid",
        "Rejected",
        "Manual Authorization",
        "Authorized",
        "Void",
      ];

      Promise.all([
        this.$store.dispatch("cache/fetch", "tenants").catch((e) => e),
        this.$store.dispatch("cache/fetch", "users").catch((e) => e),
        this.$store.dispatch("cache/fetch", "shops").catch((e) => e),
        //this.$store.dispatch("cache/fetch", "players").catch((e) => e),
        //this.$store.dispatch("cache/fetch", "onlinePlayers").catch(e => e)
        //this.$store.dispatch("cache/fetch", "thirdPartyPlayers").catch((e) => e),
      ]).finally(() => {
        this.$store
          .dispatch("ticket/fetch", paginationData)
          .then((resp) => {
            this.totalRows = resp.data.total;

            this.gross_winnings = resp.data.gross_winnings;
            this.paid_winnings = resp.data.paid_winnings;
            this.unpaid_winnings = this.gross_winnings - this.paid_winnings;
            this.total_amount = resp.data.total_amount;
            this.winning_tax = resp.data.winning_tax;

            const playerIDs = {};
            const thirdPartyPlayerIDs = {};

            resp.data.rows.forEach((item, index) => {
              if (item.etenant_id) {
                const data = tenantByID(item.etenant_id);
                if (data) {
                  item.etenant_id = {
                    to: item.etenant_id,
                    name: data.brand_name,
                  };
                } else {
                  item.etenant_id = {
                    to: null,
                    name: item.etenant_id,
                  };
                }
              }

              if (item.euser_id) {
                const data = userByID(item.euser_id);
                if (data) {
                  item.euser_id = {
                    to: item.euser_id,
                    name: data.username,
                  };
                } else {
                  item.euser_id = {
                    to: null,
                    name: item.euser_id,
                  };
                }
              }

              if (item.eshop_id) {
                const data = shopByID(item.eshop_id);
                if (data) {
                  item.eshop_id = {
                    to: item.eshop_id,
                    name: data.name,
                  };
                } else {
                  item.eshop_id = {
                    to: null,
                    name: item.eshop_id,
                  };
                }
              }

              if (item.epaid_shop_id) {
                const data = shopByID(item.epaid_shop_id);
                if (data) {
                  item.epaid_shop_id = {
                    to: item.epaid_shop_id,
                    name: data.name,
                  };
                } else {
                  item.epaid_shop_id = {
                    to: null,
                    name: item.epaid_shop_id,
                  };
                }
              }

              if (item.event_name) {
                item.event_name = {
                  to: item.eevent_id,
                  name: item.event_name,
                };
              }

              if (item.epaid_by_user_id) {
                const data = userByID(item.epaid_by_user_id);
                if (data) {
                  item.epaid_by_user_id = {
                    to: item.epaid_by_user_id,
                    name: data.username,
                  };
                } else {
                  item.epaid_by_user_id = {
                    to: null,
                    name: item.epaid_by_user_id,
                  };
                }
              }

              if (item.eauthorized_by_user_id) {
                const data = userByID(item.eauthorized_by_user_id);
                if (data) {
                  item.eauthorized_by_user_id = {
                    to: item.eauthorized_by_user_id,
                    name: data.username,
                  };
                } else {
                  item.eauthorized_by_user_id = {
                    to: null,
                    name:
                      item.eauthorized_by_user_id == "LOIQ6p7TaKDBIpfb-Pvm_A"
                        ? "cron"
                        : item.eauthorized_by_user_id,
                  };
                }
              }

              if (item.ecancel_by_user_id) {
                const data = userByID(item.ecancel_by_user_id);
                if (data) {
                  item.ecancel_by_user_id = {
                    to: item.ecancel_by_user_id,
                    name: data.username,
                  };
                } else {
                  item.ecancel_by_user_id = {
                    to: null,
                    name: item.ecancel_by_user_id,
                  };
                }
              }

              if (item.eplayer_id) {
                playerIDs[item.eplayer_id] = true;
              }

              /*
              if (item.eplayer_id) {
                const data = playerByID(item.eplayer_id);
                if (data) {
                  item.eplayer_id = {
                    to: item.eplayer_id,
                    name: `${data.name} ${data.surname}`,
                  };
                  item.cnp = data.cnp;
                } else {
                  item.eplayer_id = {
                    to: null,
                    name: item.eplayer_id,
                  };
                  item.cnp = "";
                }
              }
              */

              /*
              if (item.eonline_player_id) {
                const data = onlinePlayerByID(item.eonline_player_id);
                if (data) {
                  item.eonline_player_id = {
                    to: item.eonline_player_id,
                    name: `${data.name} ${data.surname}`
                  };
                } else {
                  item.eonline_player_id = {
                    to: null,
                    name: item.eonline_player_id
                  };
                }
              }
              */

              if (item.ethird_party_player_id) {
                thirdPartyPlayerIDs[item.ethird_party_player_id] = true;
              }

              /*
              if (item.ethird_party_player_id) {
                const data = thirdPartyPlayerByID(item.ethird_party_player_id);
                if (data) {
                  item.ethird_party_player_id = {
                    to: item.ethird_party_player_id,
                    name: `${data.name} ${data.surname} (${data.email})`,
                  };
                } else {
                  item.ethird_party_player_id = {
                    to: null,
                    name: item.ethird_party_player_id,
                  };
                }
              }
              */

              const v = item.is_valid;
              const s = item.status;

              item.is_valid = is_valid[v];

              if (v == 1) {
                item.status = status[s];
                if (s == 1) {
                  resp.data.rows[index]["_cellVariants"] = {
                    status: "success",
                  };
                }
              } else {
                item.status = s == 3 ? status[s] : "";
              }
            });

            Promise.all([
              this.$store.dispatch("cacheOnDemand/fetch", {
                key: "players",
                ids: Object.keys(playerIDs),
              }),
              this.$store.dispatch("cacheOnDemand/fetch", {
                key: "thirdPartyPlayers",
                ids: Object.keys(thirdPartyPlayerIDs),
              }),
            ])
              .then(([playersData, thirdPartyPlayersData]) => {
                resp.data.rows.forEach((item, index) => {
                  if (item.eplayer_id) {
                    const data = playersData[item.eplayer_id];
                    if (data) {
                      item.eplayer_id = {
                        to: item.eplayer_id,
                        name: `${data.name} ${data.surname}`,
                      };
                      item.cnp = data.cnp;
                    } else {
                      item.eplayer_id = {
                        to: null,
                        name: item.eplayer_id,
                      };
                      item.cnp = "";
                    }
                  }
                  if (item.ethird_party_player_id) {
                    const data =
                      thirdPartyPlayersData[item.ethird_party_player_id];
                    if (data) {
                      item.ethird_party_player_id = {
                        to: item.ethird_party_player_id,
                        name: `${data.name} ${data.surname} (${data.email})`,
                      };
                    } else {
                      item.ethird_party_player_id = {
                        to: null,
                        name: item.ethird_party_player_id,
                      };
                    }
                  }
                });
              })
              .catch((err) => {
                this.$bvToast.toast(
                  this.$t(err.message),
                  errorConf(this.$t("Error"))
                );
              });

            callback(resp.data.rows);
          })
          .catch((err) => {
            this.$bvToast.toast(
              this.$t(err.message),
              errorConf(this.$t("Error"))
            );
            this.totalRows = 0;
            callback([]);
          })
          .finally(() => {
            loading.close();
          });
      });

      // Must return null or undefined to signal b-table that callback is being used
      return null;
    },
    rowClicked(item, index, event) {
      this.$router.push("/tickets/" + item.eid);
    },
    redirect() {
      this.$router.push("/tickets/0");
    },
  },
};
</script>

<style lang="scss" scoped>
.tickets {
  & /deep/ .table th {
    font-size: 13px;
  }
  * /deep/ .table td {
    font-size: 13px;
  }
}
</style>


